import { CustomTableColumn } from "./custom-table-column";

export class ParentThingTableColumn extends CustomTableColumn {
    constructor(label: string, path: string) {
        super("parentThingId", label, path);
    }
}
